import { PageHeader } from '@verantos-dev/shared-components';

import { useOrganizationsListHeader } from '../hooks/useOrganizationsListHeader';

export const OrganizationsListHeader = () => {
  const { title, createOrganizationsActionBtn } = useOrganizationsListHeader();

  return (
    <PageHeader
      id="organizations-PageHeader"
      pageTitle={title}
      actions={createOrganizationsActionBtn}
    />
  );
};
